import React from "react";
import { Input } from "../ui/input";
import { Button } from "../ui/button";
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from "../ui/card";
import { Sparkles, Send, Loader2 } from "lucide-react";

export const AIBookingAssistant = ({ aiBookingText, setAiBookingText, parsingAiBooking, onParse }) => {
  return (
    <Card className="mb-6 border-primary/30 bg-gradient-to-r from-primary/5 via-primary/10 to-transparent">
      <CardHeader className="pb-3">
        <CardTitle className="flex items-center gap-2 text-lg">
          <Sparkles className="h-5 w-5 text-primary" />
          AI Booking Assistant
        </CardTitle>
        <CardDescription>
          Describe your booking in plain English and our AI will fill in the details for you
        </CardDescription>
      </CardHeader>
      <CardContent>
        <div className="flex gap-2">
          <Input
            placeholder='e.g., "Book a sedan for John Smith tomorrow at 9am from Sydney Airport to CBD, phone 0412345678"'
            value={aiBookingText}
            onChange={(e) => setAiBookingText(e.target.value)}
            onKeyDown={(e) => e.key === 'Enter' && !e.shiftKey && (e.preventDefault(), onParse())}
            className="flex-1"
            data-testid="ai-booking-input"
          />
          <Button
            type="button"
            onClick={onParse}
            disabled={parsingAiBooking || !aiBookingText.trim()}
            className="bg-primary hover:bg-primary/90"
            data-testid="ai-booking-submit"
          >
            {parsingAiBooking ? (
              <>
                <Loader2 className="h-4 w-4 mr-2 animate-spin" />
                Parsing...
              </>
            ) : (
              <>
                <Send className="h-4 w-4 mr-2" />
                Parse
              </>
            )}
          </Button>
        </div>
      </CardContent>
    </Card>
  );
};
